import VueApollo from 'vue-apollo';
import { parseBoolean } from '@gitlab/frontend-utils';
import { initVueApp } from '~/lib/utils/vue3compat/init_vue_app';
import { s__ } from '~/locale';
import { addShortcutsExtension } from '~/behaviors/shortcuts';
import ShortcutsIssuable from '~/behaviors/shortcuts/shortcuts_issuable';
import { initPipelineCountListener } from '~/commit/pipelines/utils';
import { initIssuableSidebar } from '~/issuable';
import MergeRequestHeader from '~/merge_requests/components/merge_request_header.vue';
import createDefaultClient from '~/lib/graphql';
import initSourcegraph from '~/sourcegraph';
import ZenMode from '~/zen_mode';
import initAwardsApp from '~/emoji/awards_app';
import toast from '~/vue_shared/plugins/global_toast';
import { pinia } from '~/pinia/instance';
import getStateQuery from './queries/get_state.query.graphql';
import initCheckoutModal from './init_checkout_modal';
import initMergeRequestTitleActions from './init_merge_request_title_actions';

export default function initMergeRequestShow() {
  new ZenMode(); // eslint-disable-line no-new
  initPipelineCountListener(document.querySelector('#commit-pipeline-table-view'));
  addShortcutsExtension(ShortcutsIssuable);
  initSourcegraph();
  initIssuableSidebar();
  initAwardsApp(document.getElementById('js-vue-awards-block'));
  initCheckoutModal();
  initMergeRequestTitleActions();

  const el = document.querySelector('.js-mr-header');
  const { hidden, imported, isDraft, iid, projectPath, state } = el.dataset;

  initVueApp({
    el,
    name: 'MergeRequestHeaderRoot',
    pinia,
    apolloProvider: new VueApollo({
      defaultClient: createDefaultClient(),
    }),
    provide: {
      query: getStateQuery,
      hidden: parseBoolean(hidden),
      iid,
      projectPath,
    },
    component: MergeRequestHeader,
    props: {
      initialState: state,
      isImported: parseBoolean(imported),
      isDraft: parseBoolean(isDraft),
    },
  });

  const copyReferenceButton = document.querySelector('.js-copy-reference');

  copyReferenceButton?.addEventListener('click', () => {
    toast(s__('MergeRequests|Reference copied'));
  });
}
